import { Component, EventEmitter, HostListener, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { LoginDataService } from 'src/app/services/dhukan/login-data.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  @ViewChild('ngOtpInput', { static: false }) ngOtpInputRef: any;
  @Output() emitData = new EventEmitter();


  countrycode: string = "+91";

  @Input() companyid: any = 0;

  //Mode Values
  @Input() issignup: boolean = false;
  @Input() islogin: boolean = false;
  isotpverification: boolean = false;
  isrequestotp: boolean = false;

  //OTP verification
  otpverifytype: string = "";
  sendotpdata: any = {}
  otpverificationno: string = "";

  //Save Validation
  signupsubmitted: boolean;
  signupsuccessfully: boolean;
  loginsubmitted: boolean;
  loginsuccessfully: boolean;

  timeLeft: number = 0;
  interval;

  mobNumberPattern = "^((\\+91-?)|0)?[0-9]{10}$";

  constructor(public activeModal: NgbActiveModal, public loginservice: LoginDataService) { }


  signupform = new FormGroup({
    firstname: new FormControl('', Validators.required),
  });

  loginform = new FormGroup({
    mobile: new FormControl(null, [Validators.required, Validators.pattern("^((\\+91-?)|0)?[0-9]{10}$")]),
  });

  ngOnInit(): void {
    try {

      this.signupform.reset();
      this.fnInitializeSignupFormGroup();

      this.loginform.reset();
      this.fnInitializeLoginFormGroup();


    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }


  fnInitializeSignupFormGroup() {
    this.signupform.setValue({
      firstname: '',  
    })

  }


  fnInitializeLoginFormGroup() {
    this.loginform.setValue({
      mobile: '',
    })
  }

  fnChangeType(type) {
    if (type === "LOGIN") {
      this.issignup = false;
      this.islogin = true;
      this.loginsubmitted = false;
      this.loginsuccessfully = false;
      this.isotpverification = false;
      this.isrequestotp = false;
      this.loginform.reset();
      this.fnInitializeLoginFormGroup();
    }
    else if (type === "SIGNUP") {
      this.issignup = true;
      this.islogin = false;
      this.signupsubmitted = false;
      this.signupsuccessfully = false;
      this.isotpverification = false;
      this.isrequestotp = false;
      this.signupform.reset();
      this.fnInitializeSignupFormGroup();
    }
  }

  fnSignupBtnClick() {
    try {
      this.signupsubmitted = true;
      this.signupsuccessfully = false;
      //Validate
      if (this.signupform.valid) {

        // let mobile = this.signupform.get('mobile').value;

        var data = {
          'companyid':this.companyid,
          'customername': this.signupform.get('firstname').value,
          'mobile': this.sendotpdata.mobile,
         // 'email': this.signupform.get('email').value,
          'otp': this.sendotpdata.otp
        }
        this.fnInsertCustomerSignUp(data);





      }
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnLoginBtnClick() {
    try {
      this.loginsubmitted = true;
      this.loginsuccessfully = false;
      //Validate
      if (this.loginform.valid) {
        let mobile = this.loginform.get('mobile').value;
        var data = {
          'companyid':this.companyid,
          'mobile': mobile,
          'autofill': 'Sdnjsf7'
        }
        this.loginservice.fnCheckCustomerLogin(data)
          .subscribe(
            (res) => {
              console.log(res.json())
              if (res.json().status == 200) {

                var _checkresult = res.json().result.checkstatus;

                if (_checkresult === 'done') {
                  var _otp = res.json().result.otp;
                  var _cusinfo = res.json().result.customerdata;

                  var logindata = {
                    'mobile': _cusinfo.mobile,
                  }

                 // alert(_cusinfo.customercheck)
                  this.otpverifytype = _cusinfo.customercheck;
                  this.fnSendOTP(logindata, _otp);
                }
                else {

                  this.fnChangeType("SIGNUP");
                  // this.signupform.patchValue({
                  //   firstname:'',      
                  //   lastname:'',      
                  //   email:'',      
                  //   mobile:this.loginform.get('mobile').value,        
                  //   prefixmobile:this.loginform.get('prefixmobile').value ,        
                  // })                
                }
              }
              else if (res.json().status == 400) {
                this.fnShowErrorMsg('Error' + res.json().err_field);
              }

            },
            (err) => {
              this.fnShowErrorMsg('Error' + err);
            })



      }
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  //OTP Verification  
  fnSendOTP(data, otp) {

    // if(this.otpverifytype==="SIGNUP"){
    //   this.issignup=false;
    // }else if(this.otpverifytype==="LOGIN"){
    //   this.islogin=false;
    // }  
    this.isotpverification = true;

    this.islogin = false;


    this.sendotpdata = data;
    this.otpverificationno = "";
    this.isrequestotp = false;
    this.sendotpdata.otp = otp;


    this.startTimer();

  }

  fnResendOtp() {

    // this.loginservice.fnSendOtp(this.sendotpdata)
    //   .subscribe(
    //     (res) => {
    //       if (res.json().status == 200) {
    //         if (this.otpverifytype === "SIGNUP") {
    //           this.issignup = false;
    //         } else if (this.otpverifytype === "LOGIN") {
    //           this.islogin = false;
    //         }
    //         this.isotpverification = true;
    //         this.otpverificationno = "";
    //         this.isrequestotp = false;
    //         this.sendotpdata.otp = res.json().otp;

    //         this.startTimer();

    //       }
    //       else if (res.json().status == 400) {
    //         this.fnShowErrorMsg('Error' + res.json().err_field);
    //       }

    //     },
    //     (err) => {
    //       this.fnShowErrorMsg('Error' + err);
    //     })
  }

  fnOtpVerificationBackClick() {
    try {


      this.islogin = true;

      this.isotpverification = false;
      this.sendotpdata = {};
      this.otpverificationno = "";
      this.isrequestotp = false;
      this.sendotpdata.otp = '';



      // if (this.otpverifytype === "SIGNUP") {
      //   this.fnChangeType("SIGNUP");
      // }
      // else if (this.otpverifytype === "LOGIN") {
      //   this.fnChangeType("LOGIN");
      // }

    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  startTimer() {
    this.timeLeft = 90;
    this.interval = setInterval(() => {
      if (this.timeLeft > 0) {
        this.timeLeft--;
      } else {
        this.isrequestotp = true;
      }
    }, 1000)
  }
  pauseTimer() {
    this.isrequestotp = false;
    clearInterval(this.interval);
  }

  //Final
  fnVerifyOTP() {


    this.otpverificationno = this.fnGetOTPContlValue(this.ngOtpInputRef.otpForm.value);

    if (this.sendotpdata.otp !== this.otpverificationno) {
      alert('Incorrect Otp');
      return
    }
    if (this.otpverifytype === "SIGNUP") {
      this.issignup = true;
      this.isotpverification = false
      // this.fnInsertCustomerSignUp();
    } else if (this.otpverifytype === "LOGIN") {
      this.fnGetCustomerLogin();
    }

  }

  //SignUp Final
  fnInsertCustomerSignUp(data) {
    //Validate

    this.pauseTimer();
    data.companyid=this.companyid;
    this.loginservice.fnInsertCustomerSignup(data)
      .subscribe(
        (res) => {
          if (res.json().status == 200) {
//console.log(res.json())
            let _checkstatus = res.json().result.checkstatus;
            if (_checkstatus == "done") {

              let _customerid = res.json().result.customerid
              this.emitData.emit(_customerid);
              this.activeModal.close(true);

            } else {
              if (_checkstatus === "mobile") {
                this.signupform.controls['mobile'].setErrors({ 'notfound': true });
              }
            }


            // console.log(res.json());
            // let _customerid=res.json().result[0].customerid;
            //  var _req={
            //    customerid:_customerid,     
            //    mobile:this.sendotpdata.mobile
            //  }


          }
          else if (res.json().status == 400) {
            this.fnShowErrorMsg('Error' + res.json().err_field);
          }

        },
        (err) => {
          this.fnShowErrorMsg('Error' + err);
        })

  }
  //Login Final
  fnGetCustomerLogin() {

    if (this.sendotpdata.otp !== this.otpverificationno) {
      alert('Incorrect Otp');
    } else {
      this.pauseTimer();

      this.sendotpdata.companyid=this.companyid
      this.loginservice.fnGetCustomerLogin(this.sendotpdata)
        .subscribe(
          (res) => {
            if (res.json().status == 200) {
              let _checkstatus = res.json().result.checkstatus;
              if (_checkstatus == "done") {

                let _customerid = res.json().result.customerid
                this.emitData.emit(_customerid);
                this.activeModal.close(true);

              } else {
                alert(_checkstatus)
              }

            }
            else if (res.json().status == 400) {
              this.fnShowErrorMsg('Error' + res.json().err_field);
            }

          },
          (err) => {
            this.fnShowErrorMsg('Error' + err);
          })


      // var _req={
      //   customerid:this.sendotpdata.customerid,     
      //   mobile:this.sendotpdata.mobile
      // }

      // this.emitData.emit(_req);  
      // this.activeModal.close(true);  
    }
  }

  fnGetOTPContlValue(data) {
    let _result = "";

    if (data.ctrl_0) {
      _result = _result + data.ctrl_0;
    }
    if (data.ctrl_1) {
      _result = _result + data.ctrl_1;
    }
    if (data.ctrl_2) {
      _result = _result + data.ctrl_2;
    }
    if (data.ctrl_3) {
      _result = _result + data.ctrl_3;
    }
    if (data.ctrl_4) {
      _result = _result + data.ctrl_4;
    }
    if (data.ctrl_5) {
      _result = _result + data.ctrl_5;
    }

    return _result;
  }

  @HostListener('window:popstate', ['$event'])
  onPopState(event) {
    this.activeModal.close(true)
  }


  private fnShowErrorMsg(ex) {
    console.log('Internal Error', ex);
  }


}
